import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const ClientPortal = ({ children, selector }) => {
  const ref = useRef();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    ref.current = document.querySelector(selector);

    setMounted(true);
  }, [selector]);

  return mounted ? createPortal(children, ref.current) : null;
};

ClientPortal.propTypes = {
  children: PropTypes.node,
  selector: PropTypes.string,
};

ClientPortal.defaultProps = {
  children: null,
  selector: 'body',
};

export default ClientPortal;
